
import { useSelector } from 'react-redux';
import { formatTimeAgo } from '../../utils/formattedDate';
import avatar from '../../assets/images/Avatar.png'
const SignUp = ({ SignupedActivities }) => {

  return (
    <div className='recent-activity-section'>
      {SignupedActivities?.map((item, index) => {
        return (
          <div className='recent-activity-card' key={index}>
            <div className='recent-activity-avatar-image'>
              <img src={item?.user?.profilePicture} alt="avatar-image" />
            </div>
            <div className='recent-activity-data'>
              <div className=''>
                <div className='name'>{item?.user?.firstName}</div>
                <span className={`type ${item?.user?.type}`}>{item?.user?.type}</span>
              </div>
              <div className='description'>{item?.activityDescription}</div>
              <div className='time'>{formatTimeAgo(item?.createdAt)}</div>
            </div>
          </div>
        )
      })}
    </div>
  )

}
export default SignUp